let currentUserId: string | null = null;

export function setCurrentUserId(userId: string | null): void {
  currentUserId = userId;
}

export function getCurrentUserId(): string {
  if (currentUserId === null) {
    throw new Error('User not authenticated');
  }
  return currentUserId;
}
